import Vue from 'vue'
import Router from 'vue-router'
import PhoneBrands from './components/PhoneBrands.vue'
import PhoneModels from './components/PhoneModels.vue'
import PhoneCategory from './components/PhoneCartegory.vue'
import PhoneDetails from './components/PhoneDetails.vue'
import UnderConstruction from './components/UnderConstruction.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        //{path: '/', name: 'home', component: UnderConstruction},
        {path: '/', name: 'home', component: PhoneBrands},
        {path: '/models', name: 'models', component: PhoneModels},
        {path: '/category', name: 'category', component: PhoneCategory},
        {path: '/details', name: 'details', component: PhoneDetails}

    ]
})
